import { Button as ButtonAntd } from 'antd'
import { clsx } from 'clsx'
import { ClickAction, useOnClickAction } from 'hook/useOnClickAction'
import { CSSProperties, ReactNode } from 'react'
import { styles } from 'util/style'
import css from './IconButton.module.scss'

type Props = {
  action?: ClickAction | false
  blur?: boolean
  children?: ReactNode
  className?: string
  disabled?: boolean
  large?: boolean
  link?: boolean
  round?: number
  size?: number
  small?: boolean
  style?: CSSProperties
  xs?: boolean
}

export function IconButton(props: Props) {
  const { blur, children, className, disabled, large, link, round, small, xs } = props
  const { busy, onClick } = useOnClickAction(props)

  const type = link ? 'link' : 'text'
  const size = props.size ?? 32
  const classes = clsx(className, css.button, blur && css.blur, busy && 'ant-btn-loading')
  const style = styles({
    ...props.style,
    borderRadius: round,
    width: size,
    height: size,
  })

  return <ButtonAntd type={type} disabled={disabled || busy}
    className={classes} style={style} onClick={onClick}>
    {children}
  </ButtonAntd>
}
